import React from 'react';
import { TwitterShareButton } from 'react-share';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SvgIcon from '../../SvgIcon';
import { socialShare } from '../../../actions';

function TwitterButtonShare(props) {
  const { url = 'https://www.givemyview.com', quote = '', slugId = '', actions } = props;
  const { socialShare: socialShareAction } = actions;
  return (
    <TwitterShareButton
      url={url}
      quote={quote}
      className='c-social__link'
      onClick={() => {
        socialShareAction(slugId);
      }}
    >
      <span className='c-social__label'>Twitter</span>
      <SvgIcon icon='x' />
    </TwitterShareButton>
  );
}

TwitterButtonShare.propTypes = {
  url: PropTypes.string.isRequired,
  quote: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      socialShare,
    },
    dispatch,
  ),
});

export default connect(null, mapDispatchToProps)(TwitterButtonShare);
